/* mapsy-vx.js – Mapsy's own replacements for the Vitals modules (2026-10-09).
 * Pure JS asset: NO Liquid inside (config comes from <script type="application/json" id="mapsy-vx-config">),
 * every feature runs in its own try/catch, nothing touches the product form submit / add-to-cart.
 * Features: delivery countdown · low stock line · back-in-stock "Meld mij" · size chart dialog ·
 *           recent-sales toast (real orders only) · email sign-up pop-up · tab title · favicon cart badge ·
 *           external links in new tab · image drag protection.
 */
(function () {
  'use strict';
  if (window.__mapsyVx) return; window.__mapsyVx = true;
  var CFG = {};
  try { var el = document.getElementById('mapsy-vx-config'); if (el) CFG = JSON.parse(el.textContent || '{}'); } catch (e) { CFG = {}; }
  var F = CFG.features || {};
  var LS = { get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} } };
  var SS = { get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} } };
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[mapsy-vx] ' + name, e); } }
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  /* ---------- 0. Signup source (13 Oct, Reels): first-party, 7 days, last-touch with a non-empty UTM; referrer domain as fallback.
     Functional storage only: UTM values + a referrer DOMAIN, no personal data, no third party. Used only to tag a pop-up signup. ---------- */
  var SRC = (function () {
    var K = 'mx_src', TTL = 7 * 864e5, out = null;
    function read() {
      var v = LS.get(K); if (!v) { var m = document.cookie.match(/(?:^|;\s*)mx_src=([^;]+)/); if (m) try { v = decodeURIComponent(m[1]); } catch (e) {} }
      try { var o = JSON.parse(v || 'null'); return o && o.t && Date.now() - o.t < TTL ? o : null; } catch (e) { return null; }
    }
    function write(o) { var v = JSON.stringify(o); LS.set(K, v); try { document.cookie = 'mx_src=' + encodeURIComponent(v) + ';path=/;max-age=' + (7 * 86400) + ';SameSite=Lax;Secure'; } catch (e) {} }
    try {
      var q = new URLSearchParams(location.search), u = {}, any = false;
      ['source', 'medium', 'campaign', 'content'].forEach(function (k) { var v = (q.get('utm_' + k) || '').trim().slice(0, 100); if (v) { u[k] = v; any = true; } });
      var cur = read();
      if (any) { out = { utm: u, ref: '', t: Date.now() }; write(out); }
      else {
        var ref = ''; try { ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
        var own = /(^|\.)mapsy\.shop$|myshopify\.com$|shopify\.com$|shopifypreview\.com$/.test(ref);
        if (cur) out = cur;
        else if (ref && !own) { out = { utm: {}, ref: ref, t: Date.now() }; write(out); }
      }
    } catch (e) {}
    function san(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function cut(t) { return t.slice(0, 40).replace(/-+$/, ''); }
    function tags() {
      var o = out || read() || { utm: {}, ref: '' }, u = o.utm || {}, s = san(u.source), m = san(u.medium), c = san(u.content), t = [];
      if (s || m || u.campaign || c) { if (m === 'reel' && c) t.push(cut('reel-' + c)); t.push(cut(s === 'instagram' && m === 'reel' ? 'src-instagram-reel' : 'src-' + (s || 'unknown'))); }
      else t.push(o.ref ? cut('src-ref-' + san(o.ref)) : 'src-direct');
      return t;
    }
    return { get: function () { return out || read() || { utm: {}, ref: '' }; }, tags: tags };
  })();
  window.__mxSrc = SRC;
  function srcSend(email, retry) {
    try { var so = SRC.get(); if (!CFG.worker || !email) return Promise.resolve(null);
      return fetch(CFG.worker + '/signup/src', { method: 'POST', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, /* simple request: no CORS preflight */
        body: JSON.stringify({ email: email, utm: so.utm || {}, ref: so.ref || '', retry: retry ? 1 : 0 }) }).then(function (r) { return r.json(); }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  // 13 Oct: WELKOM code in the thank-you step. The Worker issues it only with Shopify marketing consent; Shopify can take a few
  // seconds to create the customer, so 'pending' is retried (max ~12 s). Without a code the "komt per mail" line stays.
  function renderCode(code) {
    var dlg = document.getElementById('mx-signup'); if (!dlg || !code) return;
    var w = dlg.querySelector('[data-mx-code-wrap]'), c = dlg.querySelector('[data-mx-code]'), wait = dlg.querySelector('[data-mx-code-wait]'), cp = dlg.querySelector('[data-mx-copy]');
    if (!w || !c) return; c.textContent = code; w.hidden = false; if (wait) wait.hidden = true; var ap = dlg.querySelector('[data-mx-apply]'); if (ap) ap.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart'; try { localStorage.setItem('mx_welkom_code', JSON.stringify({ c: code, t: Date.now() })); } catch (e) {}
    if (cp && !cp.__mx) { cp.__mx = 1; cp.addEventListener('click', function () {
      function done() { cp.textContent = 'Gekopieerd ✓'; setTimeout(function () { cp.textContent = 'Kopieer'; }, 2500); }
      try { if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, function () {}); return; } } catch (e) {}
      try { var r = document.createRange(); r.selectNodeContents(c); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); document.execCommand('copy'); done(); } catch (e) {}
    }); }
  }
  function getCode(email, n) {
    return srcSend(email, n > 0).then(function (j) {
      var w = j && j.welcome; if (!w) return;
      if (w.code) return renderCode(w.code);
      if (w.pending && n < 6) setTimeout(function () { getCode(email, n + 1); }, 2000);
    });
  }
  // Shopify's bot protection re-submits the customer form natively (page reloads with ?customer_posted=true), which kills the
  // in-page fetch chain; the pending signup is kept in sessionStorage and finished here after the reload (once: flag cleared).
  safe('src_pending', function () {
    var pend = SS.get('mx_src_pending'); if (!pend || !/customer_posted=true/.test(location.search)) return;
    var o = JSON.parse(pend); SS.set('mx_src_pending', '');
    if (o && o.e && Date.now() - o.t < 15 * 60e3) { LS.set('mx_signup_done', '1'); showThanks(); getCode(o.e, o.sent ? 1 : 0); }
    function showThanks() { // modal dialog = no layout shift
      var dlg = document.getElementById('mx-signup'); if (!dlg) return;
      var f = dlg.querySelector('[data-mx-signup-form]'), t = dlg.querySelector('[data-mx-signup-thanks]'); if (!t) return;
      if (f) f.hidden = true; t.hidden = false;
      function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('mx-modal-open'); window.__mxSignupOpen = false; }
      Array.prototype.forEach.call(dlg.querySelectorAll('[data-mx-close]'), function (b) { b.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('cancel', function () { document.documentElement.classList.remove('mx-modal-open'); window.__mxSignupOpen = false; });
      setTimeout(function () { try { if (dlg.open) return; window.__mxSignupOpen = true; if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); document.documentElement.classList.add('mx-modal-open'); } catch (e) {} }, 600);
    }
  });

  /* ---------- Amsterdam time helpers (works whatever the visitor's own timezone is) ---------- */
  var TZ = 'Europe/Amsterdam';
  function amsParts(d) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', weekday: 'short' });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    var wd = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 }[o.weekday];
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, mi: +o.minute, s: +o.second, wd: wd };
  }
  function ymd(y, m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; }
  function addDays(p, n) { var t = new Date(Date.UTC(p.y, p.m - 1, p.d + n, 12)); return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), wd: t.getUTCDay() }; }
  var MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  /* ---------- 1. Delivery date line: "ma–do vóór 15:30 besteld = morgen in huis" ----------
   * Rules (config.delivery): ship days Mon–Fri, cut-off 15:30 Amsterdam time, PostNL delivers next working day (Mon–Fri),
   * holidays (YYYY-MM-DD) are skipped for both shipping and delivery. "morgen in huis" is only promised Mon–Thu before cut-off. */
  function deliveryInfo(now) {
    var D = CFG.delivery || {}; var cut = (D.cutoff || '15:30').split(':'); var cH = +cut[0], cM = +cut[1] || 0;
    var hol = D.holidays || []; var shipDays = D.ship_days || [1, 2, 3, 4, 5]; var delDays = D.delivery_days || [1, 2, 3, 4, 5];
    var p = amsParts(now); var today = { y: p.y, m: p.m, d: p.d, wd: p.wd };
    function isShip(x) { return shipDays.indexOf(x.wd) > -1 && hol.indexOf(ymd(x.y, x.m, x.d)) < 0; }
    function isDel(x) { return delDays.indexOf(x.wd) > -1 && hol.indexOf(ymd(x.y, x.m, x.d)) < 0; }
    var beforeCut = (p.h < cH) || (p.h === cH && p.mi < cM);
    var ship = today, i = 0;
    if (!(isShip(today) && beforeCut)) { ship = addDays(today, 1); while (!isShip(ship) && i++ < 14) ship = addDays(ship, 1); }
    var del = addDays(ship, 1); i = 0; while (!isDel(del) && i++ < 14) del = addDays(del, 1);
    var secsLeft = null;
    if (isShip(today) && beforeCut) secsLeft = (cH * 3600 + cM * 60) - (p.h * 3600 + p.mi * 60 + p.s);
    var tomorrow = addDays(today, 1); var isTomorrow = del.y === tomorrow.y && del.m === tomorrow.m && del.d === tomorrow.d;
    return { secsLeft: secsLeft, del: del, isTomorrow: isTomorrow };
  }
  function fmtLeft(s) { var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60); return (h > 0 ? h + ' u ' : '') + m + ' min'; }
  function deliveryText(now) {
    var x = deliveryInfo(now); var dayTxt = DAYS[x.del.wd] + ' ' + x.del.d + ' ' + MONTHS[x.del.m - 1];
    if (x.secsLeft !== null && x.secsLeft > 0 && x.isTomorrow) return { html: 'Bestel binnen <strong>' + fmtLeft(x.secsLeft) + '</strong>, <strong>morgen</strong> in huis', tick: true };
    if (x.secsLeft !== null && x.secsLeft > 0) return { html: 'Bestel binnen <strong>' + fmtLeft(x.secsLeft) + '</strong>, <strong>' + dayTxt + '</strong> in huis', tick: true };
    return { html: 'Bestel nu, <strong>' + dayTxt + '</strong> in huis', tick: false };
  }
  safe('delivery', function () {
    if (F.delivery === false) return;
    $all('[data-mx-delivery]').forEach(function (box) {
      var out = $('[data-mx-delivery-text]', box) || box;
      function render() { var t = deliveryText(new Date()); out.innerHTML = t.html; box.hidden = false; return t.tick; }
      if (render()) setInterval(function () { if (!document.hidden) render(); }, 30000);
    });
  });

  /* ---------- variant tracking (no theme internals needed) ---------- */
  var V = CFG.variants || null;            // [{id, available, qty|null, policy}]
  var currentVariantId = null;
  var variantListeners = [];
  function readVariantId() {
    var inp = $('form[action*="/cart/add"] [name="id"]');
    var v = inp && inp.value ? inp.value : null;
    if (!v) { try { v = new URL(location.href).searchParams.get('variant'); } catch (e) {} }
    return v || (CFG.selected_variant_id ? String(CFG.selected_variant_id) : null);
  }
  function variantById(id) { if (!V) return null; for (var i = 0; i < V.length; i++) if (String(V[i].id) === String(id)) return V[i]; return null; }
  function checkVariant() {
    var id = readVariantId(); if (!id || id === currentVariantId) return;
    currentVariantId = id; var v = variantById(id);
    variantListeners.forEach(function (fn) { safe('variant-listener', function () { fn(v); }); });
  }
  if (V) {
    ['change', 'click', 'input'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(checkVariant, 60); }, true); });
    window.addEventListener('popstate', function () { setTimeout(checkVariant, 60); });
    try { if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(checkVariant, 30); }); } catch (e) {}
  }

  /* ---------- 2. Low stock line ("Nog X op voorraad") – real inventory only ----------
   * Liquid only passes qty when inventory is tracked AND (policy = deny OR config allows 'continue'),
   * so oversellable placeholder stock never produces fake scarcity. */
  safe('lowstock', function () {
    if (F.lowstock === false || !V) return;
    var box = $('[data-mx-lowstock]'); if (!box) return;
    var max = (CFG.lowstock && CFG.lowstock.max) || 3;
    variantListeners.push(function (v) {
      var q = v && v.available && typeof v.qty === 'number' ? v.qty : null;
      if (q !== null && q > 0 && q <= max) { box.textContent = q === 1 ? 'Nog 1 op voorraad in deze maat' : 'Nog ' + q + ' op voorraad in deze maat'; box.hidden = false; }
      else { box.hidden = true; box.textContent = ''; }
    });
  });

  /* ---------- 3. Back in stock "Meld mij" (mapsy-flows Worker, Mapsy-only) ---------- */
  safe('bis', function () {
    if (F.bis === false || !V) return;
    var box = $('[data-mx-bis]'); if (!box) return;
    var form = $('form', box), msg = $('[data-mx-bis-msg]', box), vin = $('[name="variant_id"]', box);
    variantListeners.push(function (v) {
      var show = !!(v && !v.available);
      box.hidden = !show; if (vin && v) vin.value = v.id;
      if (show && msg && !box.getAttribute('data-done-' + v.id)) { msg.textContent = ''; if (form) form.hidden = false; }
    });
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ($('[name="email"]', form) || {}).value || '';
      var ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email.trim());
      if (!ok) { msg.textContent = 'Vul een geldig e-mailadres in.'; return; }
      if (($('[name="website"]', form) || {}).value) return; // honeypot
      var btn = $('button[type="submit"]', form); if (btn) btn.disabled = true;
      fetch((CFG.worker || '') + '/bis/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ email: email.trim(), variant_id: String(vin.value), handle: CFG.product_handle, product_id: CFG.product_id }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok && res.j && res.j.ok) { msg.textContent = 'Gelukt! We mailen je één keer zodra deze maat weer op voorraad is.'; form.hidden = true; box.setAttribute('data-done-' + vin.value, '1'); }
          else msg.textContent = 'Dat lukte niet. Probeer het later nog eens of mail hello@mapsy.shop.';
        })
        .catch(function () { msg.textContent = 'Dat lukte niet. Probeer het later nog eens of mail hello@mapsy.shop.'; })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  if (V) setTimeout(checkVariant, 0);

  /* ---------- 4. Size chart dialog ---------- */
  safe('sizechart', function () {
    var dlg = $('#mx-sizechart'); if (!dlg) return;
    $all('[data-mx-sizechart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); document.documentElement.classList.add('mx-modal-open'); }); });
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('mx-modal-open'); }
    $all('[data-mx-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('mx-modal-open'); });
  });

  /* ---------- helpers for floating UI: never on top of drawers / modals / checkout bars ---------- */
  function overlayBusy() {
    var h = document.documentElement, b = document.body;
    var cb = document.getElementById('shopify-pc__banner');
    var cookieOpen = !!(cb && cb.offsetParent !== null && getComputedStyle(cb).display !== 'none' && getComputedStyle(cb).visibility !== 'hidden');
    return cookieOpen || h.classList.contains('mx-drawer-open') || h.classList.contains('mx-modal-open') || (b && b.classList.contains('no-scroll')) || !!$('dialog[open]');
  }

  /* ---------- 5. Recent sales toast – REAL orders only (Worker /sp/recent), nothing when empty ---------- */
  safe('proof', function () {
    var P = CFG.proof || {}; if (F.proof === false || !CFG.worker) return;
    if (isMobile && !P.mobile) return;                         // Vitals showed it on desktop only
    if (/^\/(cart|checkout|account)/.test(location.pathname)) return;
    if (SS.get('mx_proof_off')) return;
    var shown = +(SS.get('mx_proof_n') || 0), maxN = P.max_per_session || 4;
    if (shown >= maxN) return;
    function go(items) {
      if (!items || !items.length) return;
      var idx = shown % items.length, box = null;
      function show() {
        if (document.hidden || overlayBusy() || +(SS.get('mx_proof_n') || 0) >= maxN || SS.get('mx_proof_off') || window.__mxSignupOpen) return schedule();
        var it = items[idx++ % items.length];
        if (!box) {
          box = document.createElement('div'); box.className = 'mx-proof'; box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite');
          document.body.appendChild(box);
        }
        box.innerHTML = '<a class="mx-proof__link" href="/products/' + encodeURIComponent(it.handle) + '">' +
          (it.image ? '<img class="mx-proof__img" src="' + esc(it.image) + '" alt="" width="56" height="56" loading="lazy">' : '') +
          '<span class="mx-proof__txt"><span class="mx-proof__who">' + esc(it.who) + ' kocht</span><span class="mx-proof__title">' + esc(it.title) + '</span><span class="mx-proof__when">' + esc(it.when) + '</span></span></a>' +
          '<button type="button" class="mx-proof__x" aria-label="Sluiten">&times;</button>';
        $('.mx-proof__x', box).addEventListener('click', function () { SS.set('mx_proof_off', '1'); box.classList.remove('is-in'); });
        box.classList.add('is-in'); SS.set('mx_proof_n', String(+(SS.get('mx_proof_n') || 0) + 1));
        setTimeout(function () { box && box.classList.remove('is-in'); schedule(); }, (P.display_s || 6) * 1000);
      }
      function schedule(first) { setTimeout(show, ((first ? P.first_delay_s : P.interval_s) || (first ? 15 : 25)) * 1000); }
      schedule(true);
    }
    var cached = SS.get('mx_proof_cache');
    if (cached) { try { var c = JSON.parse(cached); if (c.t > Date.now() - 600000) return go(c.items); } catch (e) {} }
    fetch(CFG.worker + '/sp/recent', { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (j) { var items = (j && j.items) || []; SS.set('mx_proof_cache', JSON.stringify({ t: Date.now(), items: items })); go(items); })
      .catch(function () {});
  });

  /* ---------- 6. Email sign-up pop-up (explicit consent → Shopify customer form → mapsy-flows welcome flow) ---------- */
  safe('signup', function () {
    var S = CFG.signup || {}; if (F.signup === false || !S.enabled) return;
    var dlg = $('#mx-signup'); if (!dlg) return;
    if (/^\/(cart|checkout|account|pages\/contact)/.test(location.pathname)) return;
    if (CFG.customer_subscribed || LS.get('mx_signup_done')) return;
    var snooze = +(LS.get('mx_signup_snooze') || 0); if (snooze > Date.now()) return;
    var pv = +(SS.get('mx_pv') || 0) + 1; SS.set('mx_pv', String(pv));
    var opened = false;
    var tries = 0;
    function open() {
      if (opened) return;
      if (overlayBusy() || document.hidden) { if (tries++ < 24) setTimeout(open, 5000); return; } // wait for cookie banner / drawer / other dialog
      opened = true; window.__mxSignupOpen = true;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('mx-modal-open');
    }
    function close(days) {
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      window.__mxSignupOpen = false; document.documentElement.classList.remove('mx-modal-open');
      if (days) LS.set('mx_signup_snooze', String(Date.now() + days * 864e5));
    }
    $all('[data-mx-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { close(S.snooze_days || 14); }); });
    dlg.addEventListener('cancel', function () { close(S.snooze_days || 14); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(S.snooze_days || 14); });
    var form = $('form', dlg), msg = $('[data-mx-signup-msg]', dlg);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = ($('[name="contact[email]"]', form) || {}).value || '', ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(em.trim());
      var consent = $('[name="mx_consent"]', form);
      if (!ok) { msg.textContent = 'Vul een geldig e-mailadres in.'; return; }
      if (consent && !consent.checked) { msg.textContent = 'Vink aan dat je de Mapsy-mail wilt ontvangen.'; return; }
      var btn = $('button[type="submit"]', form); if (btn) btn.disabled = true;
      SS.set('mx_src_pending', JSON.stringify({ e: em.trim(), t: Date.now() })); function srcBeacon() { SS.set('mx_src_pending', JSON.stringify({ e: em.trim(), t: Date.now(), sent: 1 })); getCode(em.trim(), 0); }
      var fd = new FormData(form); fd.delete('mx_consent');
      try { var ti = $('[name="contact[tags]"]', form); if (ti) { if (!ti.hasAttribute('data-base')) ti.setAttribute('data-base', ti.value); var base = ti.getAttribute('data-base'); ti.value = (base ? base + ',' : '') + SRC.tags().join(','); fd.set('contact[tags]', ti.value); } } catch (e) {} // also covers the captcha fallback (native submit)
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (/challenge/.test(r.url || '')) { srcBeacon(); LS.set('mx_signup_done', '1'); var c = $('[name="mx_consent"]', form); if (c) c.removeAttribute('name'); HTMLFormElement.prototype.submit.call(form); return; } // Shopify captcha: let the visitor finish it on Shopify's page
          if (!r.ok || !/customer_posted=true/.test(r.url || '')) throw new Error('not posted ' + r.status);
          LS.set('mx_signup_done', '1'); srcBeacon();
          $('[data-mx-signup-form]', dlg).hidden = true; $('[data-mx-signup-thanks]', dlg).hidden = false;
        })
        .catch(function () { msg.textContent = 'Dat lukte niet. Probeer het later nog eens.'; })
        .then(function () { if (btn) btn.disabled = false; });
    });
    var delay = (S.delay_s || 20) * 1000; if (pv < (S.min_pageviews || 1)) return;
    setTimeout(open, delay);
    if (!isMobile && S.exit_intent !== false) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) open(); });
  });

  /* ---------- 6b. "Vaak samen gekocht" – only real co-purchases (>= 2 orders), else nothing (the PDP already has related products) ---------- */
  safe('fbt', function () {
    if (F.fbt === false || !CFG.fbt_url) return;
    var box = $('[data-mx-fbt]'); if (!box) return;
    var h = box.getAttribute('data-handle');
    fetch(CFG.fbt_url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var list = j && j.fbt && j.fbt[h] ? j.fbt[h].filter(function (x) { return x[1] >= 2; }).slice(0, 3) : [];
      if (!list.length) return;
      return Promise.all(list.map(function (x) { return fetch('/products/' + encodeURIComponent(x[0]) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (ps) {
          ps = ps.filter(function (p) { return p && p.available; }); if (!ps.length) return;
          var money = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
          box.innerHTML = '<p class="mx-fbt__h">Vaak samen gekocht</p><div class="mx-fbt__row">' + ps.map(function (p) {
            var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=200' : p.featured_image + '?width=200') : '';
            return '<a class="mx-fbt__card" href="/products/' + encodeURIComponent(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
              '<span class="mx-fbt__t">' + esc(p.title) + '</span><span class="mx-fbt__p">' + money(p.price) + '</span></a>';
          }).join('') + '</div>';
          box.hidden = false;
        });
    }).catch(function () {});
  });

  /* ---------- 7. Small Vitals extras ---------- */
  safe('tabtitle', function () {   // Vitals module 13: "☞ Vergeet dit niet..." when the tab is in the background
    if (F.tabtitle === false) return; var orig = document.title, txt = (CFG.tabtitle || '☞ Vergeet dit niet...');
    document.addEventListener('visibilitychange', function () { if (document.hidden) { orig = document.title; document.title = txt; } else document.title = orig; });
  });
  safe('favicon-badge', function () {   // Vitals module 10: cart count on the favicon (red circle, white digits)
    if (F.favicon_badge === false) return;
    var link = $('link[rel~="icon"]'); if (!link || !link.href) return;
    var base = link.href, img = new Image(); img.crossOrigin = 'anonymous';
    function draw(n) {
      if (!n) { link.href = base; return; }
      try {
        var c = document.createElement('canvas'); c.width = c.height = 32; var x = c.getContext('2d'); x.drawImage(img, 0, 0, 32, 32);
        x.fillStyle = '#ff0101'; x.beginPath(); x.arc(10, 10, 10, 0, 2 * Math.PI); x.fill();
        x.fillStyle = '#fff'; x.font = 'bold 14px sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillText(n > 9 ? '9+' : String(n), 10, 11);
        link.href = c.toDataURL('image/png');
      } catch (e) { link.href = base; }
    }
    function refresh() { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { draw(j.item_count || 0); }).catch(function () {}); }
    img.onload = function () { draw(+CFG.cart_count || 0); }; img.src = base;
    try { if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); }); } catch (e) {}
    document.addEventListener('cart:updated', function () { setTimeout(refresh, 300); });
  });
  safe('extlinks', function () {   // Vitals module 5: external links open in a new tab
    if (F.extlinks === false) return;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="http"]') : null;
      if (a && a.hostname && a.hostname !== location.hostname && !/(^|\.)mapsy\.shop$/.test(a.hostname) && !a.target) { a.target = '_blank'; a.rel = 'noopener'; }
    }, true);
  });
})();
